// extracted by mini-css-extract-plugin
export default {"predefinedQuestionsContainer":"HelpAndSupportModal_predefinedQuestionsContainer__6sfmo","predefinedQuestionButton":"HelpAndSupportModal_predefinedQuestionButton__jvyCB"};